// utility functions for data manipulation and cloning

// creates a deep clone of an object/array using structuredClone (faster and more robust) Falls back to JSON.parse(JSON.stringify()) for older browsers or unsupported types
export const deepClone = (obj) => {
  if (obj === null || obj === undefined) {
    return obj;
  }
  
  // Use structuredClone if available (modern browsers - Chrome 98+, Firefox 94+, Safari 15.4+)
  if (typeof structuredClone !== 'undefined') {
    try {
      return structuredClone(obj);
    } catch (error) {
      // structuredClone failed (e.g., circular refs, unsupported types) - fallback to JSON method
      console.warn('structuredClone failed, falling back to JSON method:', error);
    }
  }
  
  // Fallback for older browsers or when structuredClone fails
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (error) {
    console.error('error cloning object:', error, 'Object:', obj);
    // Return shallow copy as last resort
    if (Array.isArray(obj)) {
      return [...obj];
    } else if (typeof obj === 'object') {
      return { ...obj };
    }
    return obj;
  }
};

// validates that data is a valid array with at least one element
export const isValidArray = (data) => {
  return Array.isArray(data) && data.length > 0;
};

// normalizes data to always be an array
export const normalizeToArray = (data) => {
  if (Array.isArray(data)) {
    return data;
  }
  if (data && typeof data === 'object') {
    return [data];
  }
  return [];
};

// checks if two values are equal (handles null/undefined/empty string edge cases)
export const valuesEqual = (a, b) => {
  return a === b || 
    (a === null && b === '') || 
    (a === '' && b === null) ||
    (a === undefined && b === '') ||
    (a === '' && b === undefined);
};

export const setValueAtPath = (obj, path, value) => {
  const normalizedPath = path.replace(/\[(\d+)\]/g, '.$1');
  const keys = normalizedPath.split('.').filter(Boolean);
  if (keys.length === 0) return obj;

  const result = deepClone(obj);
  let current = result;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    const nextKey = keys[i + 1];
    const isArrayIndex = /^\d+$/.test(nextKey);

    if (current[key] === undefined || current[key] === null) {
      if (Array.isArray(current) && /^\d+$/.test(key) && parseInt(key, 10) >= current.length) {
        return obj;
      }
      current[key] = isArrayIndex ? [] : {};
    }
    current = current[key];
  }

  const lastKey = keys[keys.length - 1];
  const emptyValue = value === '(leeg)' || value === '' ? null : value;
  current[lastKey] = emptyValue;
  return result;
};

export const getValueAtPath = (obj, path) => {
  const normalizedPath = path.replace(/\[(\d+)\]/g, '.$1');
  const keys = normalizedPath.split('.').filter(Boolean);
  let current = obj;
  for (const key of keys) {
    if (current === undefined || current === null) return undefined;
    current = current[key];
  }
  return current;
};

